module.exports = __webpack_public_path__ + "bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bb.svg
// module id = 693
// module chunks = 0